import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface Notification {
  icon: string;
  title: string;
  desc: string;
}

@Component({
  selector: 'app-crm-mobile',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './crm-mobile.html',
  styleUrls: ['./crm-mobile.css'],
})
export class CrmMobileComponent {
  readonly notifications: Notification[] = [
    { icon: '🎯', title: 'New lead assigned', desc: 'Ali Raza — Retail Store' },
    { icon: '⏰', title: 'Follow-up due in 30 min', desc: 'Sara Ahmed — Deal: Proposal' },
    { icon: '✅', title: 'Deal marked as won', desc: '$4,200 — Golden Green Store' },
  ];
}
